import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

const tones = {
  sun: 'border-sun/60 text-sun-ink',
  coral: 'border-coral/50 text-coral-ink',
  ink: 'border-ink/25 text-ink',
}

/** Etichetta di stato: filetto sottile e testo piccolo, come una nota a margine. */
export function Stamp({ children, tone = 'sun', className }: { children: ReactNode; tone?: keyof typeof tones; className?: string }) {
  return (
    <span className={cn('inline-flex items-center rounded-full border px-3 py-1 font-body text-xs font-medium', tones[tone], className)}>
      {children}
    </span>
  )
}
